import { Store } from '@ngrx/store';
import { filter, switchMap } from 'rxjs';

import { accountState } from '../../state/account/account.selectors';
import { AppFeatureFlagsHttpService } from '@ciphr/core/app-feature-flags';

export const ssoFeatureFlagsFactory = (store: Store, appFeatureFlagsHttpService: AppFeatureFlagsHttpService) => () => {
  store
    .select(accountState)
    .pipe(
      filter((accountState) => !!accountState.userName),
      switchMap(() => appFeatureFlagsHttpService.fetchFeatureFlags()),
    )
    .subscribe();
};
